//dependencies
import React from "react";
import { Doughnut } from "react-chartjs-2";

import { Spinner } from "@performyard/py-components";

//components
import Link from "../../../../../../../../../components/Link";
import Typography from "../../../../../../../../../components/Text";

import { useRbacObjectPermissions } from "../../../../../../../../../api/hooks";

//services
import { Goal } from "../../../../../../../../../api/services";

import toEmployeeUrl from "../../../../../../../../../utils/URLs/Employee";
// utils
import { getColor } from "../../../../../../../../../utils/getColor";

//css
import css from "./GoalList.module.scss";

type GoalListEntryProps = {
	goal: Goal;
};

const GoalListEntry = ({ goal }: GoalListEntryProps) => {
	const { target, value, color, _id, assignee, name } = goal;
	const { data: rbac, isLoading } = useRbacObjectPermissions("goal", _id);

	const canUserViewDetails = rbac?.includes("goals:viewDetails");
	if (isLoading) {
		return (
			<div className="flex h-full items-center justify-center">
				<Spinner size={20} />
			</div>
		);
	}

	return (
		<div className={css.goalListItem}>
			<div>
				<Doughnut
					width={30}
					options={{
						animation: false,
						events: [],
						plugins: {
							tooltip: {
								enabled: false,
							},
							legend: {
								display: false,
							},
						},
					}}
					data={{
						datasets: [
							{
								data: [value, target - value],
								backgroundColor: [color?.color || getColor("primary", 5), "#D8D8D8"],
								borderWidth: 0,
							},
						],
					}}
				/>
			</div>

			<div className={css.goalDetails}>
				{canUserViewDetails ? (
					<Link
						href={`/goal/${_id}/`}
						// we will want to remove this once the goal tooltips are moved to react
						forceHardReload={true}
					>
						<Typography size="paragraph-3" weight="semi-bold" color="primary-5">
							{name}
						</Typography>
					</Link>
				) : (
					<Typography size="paragraph-3" weight="semi-bold">
						{name}
					</Typography>
				)}
				<Link href={toEmployeeUrl(assignee?._id)} forceHardReload={true}>
					<Typography size="caption" weight="regular" color="neutral-7">
						{assignee?.name}
					</Typography>
				</Link>
			</div>
		</div>
	);
};

export default GoalListEntry;
